<div class="round" (keydown)="onKeyDown($event)" tabindex="1">
    <div class="loading-spinner" *ngIf="isLoading">
        <img src="../../assets/img/spinner.svg" alt="Loading"/>
    </div>

    <div *ngIf="!isLoading && !isAvailable" class="common-error-container">
        <div class="common-error-header">Round is not available</div>
    </div>
    <div *ngIf="isAvailable">
        <div class="round-info">
            <div>
                <span class="title">{{settings.course.name | truncate:50}}</span>
            </div>
            <div class="subtitle">
                <span class="item" *ngIf="info">{{info.startTimestampMs | timezone: info.timezoneOffset | date: 'dd MMM yyyy' : 'UTC'}}</span>
                <span class="item">{{settings.course.holes.length}} holes par {{getTotalPar(settings.course)}}</span>
                <span class="item">{{getScoringMethod(settings.scoringMethod, settings.handicapMode)}}</span>
                <span class="item units" units-selection></span>
            </div>
        </div>
        <div class="content">
            <div class="map-container">
                <app-map [settings]="settings" [holeIndex]="currentHoleIndex"></app-map>

                <div class="hole-info-overlay">
                    <div>
                        <div class="label">Hole</div>
                        <div class="value">{{currentHoleIndex + 1}}</div>
                    </div>
                    <div>
                        <div class="label">Par</div>
                        <div class="value">{{getHolePar(currentHoleIndex)}}</div>
                    </div>
                </div>
                <span (click)="prevHole()" class="arrow-left"></span>
                <span (click)="nextHole()" class="arrow-right"></span>
            </div>

            <app-scorecard [scorecard]="scorecard"></app-scorecard>
        </div>
    </div>
</div>



